import { Fragment, useRef } from 'react';
import * as R from 'remeda';
import { useIntl } from 'react-intl';
import { ContentGroup } from '@rossum/components/content-group/ContentGroup';
import { Skeleton, Stack, TextField } from '@rossum/ui/material';

export const FormSkeleton = () => {
  const intl = useIntl();

  const descriptionWidths = useRef(
    Array.from({ length: 6 }, () => `${R.randomInteger(80, 100)}%`)
  ).current;

  return (
    <Stack px={4} py={8} direction="row" spacing={4}>
      <ContentGroup
        title={<Skeleton width={200} height={40} />}
        description={
          <Stack>
            {descriptionWidths.map((width, index) => (
              <Fragment
                // oxlint-disable-next-line react/no-array-index-key
                key={`${width}-${index}`}
              >
                <Skeleton width={width} />
                {index % 3 === 0 && <br />}
              </Fragment>
            ))}
          </Stack>
        }
      >
        <Stack width={1} spacing={4}>
          <TextField
            label={intl.formatMessage({
              id: 'features.queueSettings.fields.form.label.label',
            })}
            value=" "
            variant="outlined"
            disabled
          />
          <TextField
            label={intl.formatMessage({
              id: 'features.queueSettings.fields.form.id.label',
            })}
            value=" "
            variant="outlined"
            disabled
          />
        </Stack>
      </ContentGroup>
    </Stack>
  );
};
